module.exports = __webpack_public_path__ + "img/live-casino.4b6474f0.png";